export default {
  contract_whelps: {
    1: '0xa8934086a260F8Ece9166296967D18Bd9C8474A5', // Ethereum Mainnet
    4: '0x3d57202a40a3a98896AaeA9159aa6707758209A3', // Ethereum Rinkeby
    137: '0x1f5567d9d3Efa79C4b03Beb42491344111efBDF5' // Polygon Mainnet
  },
  contract_proxy: {
    1: '0xC78Fd06Aed27d45A6Dc7dffeD3345a05e6d9F157',
    4: '0xEBBa90Fe9A836e8d9883899F7540e080281984a0',
    137: '0x70f4F927c487D118824Afec2d594Bc9Aa5091efc'
  },
  contract_staking: {
    1: '0x74936255B060c40d1067EA5737434b2B9F7C7B72',
    4: '0xB4fa11646b8E1c7eF759A0446a2667C819baE415',
    137: '0x4542CA23dFCcEF125644b640aeF60ef66e7BB1C6'
  },
  contract_staking_v2: {
    1: '0xF7FA048Fb526Ab10bCAbBe3ace5Df0af3865F25C',
    4: '',
    137: '0x3866d487e7a958f2259912b43b644917Fc033d6E'
  },
  contract_7thbreed: {
    1: '0x4935670d215DC11ED8360aC5411E9AFeFD953346',
    4: '0x3C74154c8733E568E7A5Affac87E9155e303F235',
    137: '0xCAd3Fe793ca6C185618e789A19fbBef04D14ef5F'
  }
}